<template>
    <div class="row">
        <div class="col-12">
            <TitleComponent title="Confirmación de la compra"/>
        </div>
        <div class="col-12">
            <div class="row">
                <div v-for="(entrada, index) in datos_compra.datos_compradores" :key="index" class="col-12 bg-light mb-3">
                    <h2>
                        <strong>
                            <span class="text-primary">ENTRADA {{ ++index }}: </span>
                            <span>
                                <template v-if="entrada.numero">
                                    {{ 'PLAZA: ' + entrada.numero }}
                                </template>
                                <template v-else-if="entrada.asiento">
                                    <span> {{ entrada.asiento.zona_nombre }}</span>
                                    <span v-if="entrada.asiento.row"> / FILA: {{ entrada.asiento.row }}</span>
                                    <span v-if="entrada.asiento.asiento">/ BUTACA: {{ entrada.asiento.asiento }}</span>
                                </template>
                                <template v-else-if="entrada.butaca">
                                    <span v-if="entrada.sector_name">SECTOR: {{ entrada.sector_name + ' / ' }}</span>
                                    <span>FILA: {{ entrada.fila }} </span>
                                    <span>/ BUTACA: {{ entrada.butaca }}</span>
                                </template>
                                - PRECIO:
                                <span :style="entrada.descuento && entrada.descuento.slice(-3).trim() > 0 ? 'text-decoration:line-through' : ''">{{ (datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : getPrecioEntrada(entrada.precio)) | formatear_precio }}</span>
                                <span v-if="entrada.descuento && entrada.descuento.slice(-3).trim() > 0" class="text-primary"> ({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : calcularDescuento(getPrecioEntrada(entrada.precio), entrada.descuento.trim()) | formatear_precio }} / - {{ entrada.descuento.trim() }}%)</span>
                            </span>
                        </strong>
                    </h2>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h2>
                <strong>
                    TOTAL:
                    <span class="display-4" :style="total_descuento != total ? 'text-decoration:line-through' : ''">{{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total | formatear_precio }} </span>
                    <span v-if="total_descuento != total" class="display-4 text-primary">({{ datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10 ? 0 : total_descuento | formatear_precio }})</span>
                </strong></h2>
        </div>
        <div class="col-12">
            <h2><strong>FORMA DE PAGO: <span class="display-4">{{ datos_compra.metodo_pago.nombre }}</span></strong></h2>
            <PaymentCalculator class="mb-3" :amountDue="totalPaymentCalculator" v-if="totalPaymentCalculator > 0 && datos_compra.metodo_pago.id == 1" />
        </div>
        <div class="col-12 d-flex" v-if="!compra_finalizada">
            <template v-if="datos_compra.metodo_pago.id == 3 && datafono_data">
                <DatafonoComponent
                    :importe="total_descuento"
                    @pagoCorrecto="procesarCompraDatafono"
                    @volverAtras="volverAtras"
                />
            </template>
            <Button v-else @click="procesarCompra" :disabled="loading || error" :ignoreBaseClasses="true" customClass="btn btn-primary">
                <span v-if="datos_compra.metodo_pago.id == 6 || datos_compra.metodo_pago.id == 10">
                    <span v-if="email || tieneEnvioWhatsapp">Enviar invitaciones</span>
                    <span v-else>Imprimir invitaciones</span>
                </span>
                <span v-else>
                    Finalizar compra
                </span>
            </Button>
            <Button
                customClass="btn btn-primary ml-2"
                @click="volverAtras"
                :disabled="loading"
            >
                ATRÁS
            </Button>

            <div class="col-12" v-if="loading" style="height: 120px">
                <LoaderComponent/>
            </div>

        </div>
        <div class="col-12" v-else ref="confirmacionCompra">
            <template v-if="!loading">
                <div>
                    <template v-if="qr_codes.length > 0">
                        <div class="row">
                            <div class="col-auto mb-2 mb-md-0">
                                <Button
                                    as="a"
                                    :href="imprimir_url | formatear_url({ '%EVENTO_ID%' : $route.params.evento_id, '%SESION_ID%' : $route.params.sesion_id, 'qr_codes' : qr_codes, 'tid': configuracion.hash_teatro })"
                                    target="_blank"
                                    customClass="btn btn-primary"
                                >
                                    IMPRIMIR ENTRADAS
                                </Button>
                            </div>
                            <div class="col-auto">
                                <Button
                                    as="a"
                                    :href="api_base + '/f/partidos/entradas/pdf?qr_codes=' + [qr_codes] + '&event_id=' + $route.params.evento_id + '&tid=' + configuracion.hash_teatro"
                                    target="_blank"
                                    customClass="btn btn-primary"
                                >
                                    DESCARGAR ENTRADAS EN PDF
                                </Button>
                            </div>
                        </div>
                    </template>

                    <Button
                        as="a"
                        customClass="ml-2"
                        :href="whatsapp_url"
                        target="_blank"
                        v-if="whatsapp_url"
                    >
                        ENVIAR ENTRADAS POR WHATSAPP
                    </Button>
                </div>
                <div v-if="datos_compra.metodo_pago.nombre === 'TARJETA'">
                    <Button
                        as="a"
                        customClass="mt-3 btn btn-primary"
                        :href="api_base + '/eventos/' + $route.params.evento_id + '/estado/' + $route.params.sesion_id + '/pedido/' + pedido + '/imprimir-recibo?tid=' + configuracion.hash_teatro + '&api_key=' + api_key"
                        target="_blank"
                    >
                        Imprimir recibo de compra
                    </Button>
                </div>
            </template>
            <div class="col-12" v-else style="height: 120px">
                <LoaderComponent/>
            </div>
        </div>
        <div class="col-12 mt-3" v-if="compra_finalizada && !loading">
            <div class="alert alert-success alert-dismissible">
                <h5><i class="icon fas fa-check"></i> ¡Compra finalizada correctamente!</h5>
                <template v-if="recinto && evento?.place_obj?.tipo_svg_taquilla != 2 && evento?.place_obj?.tipo_proceso_taquilla != 3">
                    <b-row>
                        <b-col sm="12" md="4" class="mb-3 pr-1">
                            <b-button block @click="goTo(1)">Volver a selección de zona</b-button>
                        </b-col>
                        <b-col sm="12" md="4" class="pl-3">
                            <b-button block v-if="mode === 1" @click="goTo(2, datos_compra.zona_id)">Continuar en esta zona</b-button>
                        </b-col>
                    </b-row>
                </template>
                <template v-else>
                    <Button @click="goTo(2)">Otra venta</Button>
                </template>
            </div>
        </div>
        <div class="col-12 mt-3" v-if="error">
            <div class="alert alert-danger alert-dismissible">
                <h5>{{ error }}</h5>
                <template v-if="recinto && evento?.place_obj?.tipo_svg_taquilla != 2 && evento?.place_obj?.tipo_proceso_taquilla != 3">
                    <Button @click="goTo(1)">Volver a selección de zona</Button>
                    <Button v-if="mode === 1" class="ml-3" @click="goTo(2, datos_compra.zona_id)">Continuar en esta zona</Button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import PaymentCalculator from '@/components/common/PaymentCalculator';
    import DatafonoComponent from '@/components/backend/datafono/DatafonoComponent';
    import Button from '@/modules/admin/ui/Button.vue'

    export default {
        props: ['datos_compra', 'email', 'carrito_id', 'recinto', 'mode', 'amigo_abonado_id', 'evento'],
        data() {
            return {
                loading: false,
                compra_finalizada: false,
                // Un solo desplazamiento por confirmación: se marca al bajar y se
                // ignora cualquier aviso posterior del mismo bloque.
                confirmacion_desplazada: false,
                qr_codes: null,
                mensaje_email: null,
                whatsapp_url: null,
                imprimir_url: null,
                api_base: process.env.VUE_APP_API_BASE,
                error: null,
                pedido: null
            }
        },
        created() {
            this.imprimir_url = this.config.IMPRIMIR_URL;
        },
        computed: {
            api_key() {
                return localStorage.getItem('token');
            },
            tieneEnvioWhatsapp() {
                return this.datos_compra.datos_compradores?.some(comprador => comprador.enviar_whatsapp === 1);
            },
            datafono_data() {
                if (this.evento && this.evento.compania) {
                    if (this.evento.compania.nif) {
                        let datafono = null;

                        if (this.evento.compania.datafono_propio) {
                            datafono = this.$store.getters.getUser.datafonos.find(datafono => datafono.nif === this.evento.compania.nif);
                        } else {
                            datafono = this.$store.getters.getUser.datafonos.find(datafono => datafono.nif === 'compralaentrada');
                        }

                        this.$store.dispatch('setActiveDatafono', datafono);
                        return datafono;
                    }
                }

                return null;
            },
            total() {
                var total = 0;
                if(this.datos_compra.datos_compradores != undefined) {
                    for(var i in this.datos_compra.datos_compradores) {
                        total += this.getPrecioEntrada(this.datos_compra.datos_compradores[i].precio);
                    }
                }

                return total;
            },
            total_descuento() {
                var total = 0;
                if(this.datos_compra.datos_compradores != undefined) {
                    for(var i in this.datos_compra.datos_compradores) {
                        var total_entrada_2 = this.getPrecioEntrada(this.datos_compra.datos_compradores[i].precio);
                        var descuento = this.datos_compra.datos_compradores[i].descuento ? this.datos_compra.datos_compradores[i].descuento.slice(-3).trim() : this.datos_compra.datos_compradores[i].descuento;
                        total = total + this.calcularDescuento(total_entrada_2, descuento);
                    }
                }

                return total;
            },
            totalPaymentCalculator() {
                return this.total != this.total_descuento ? this.total_descuento : this.total;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            /**
             * La confirmación con sus botones no existe hasta que la compra termina
             * (`compra_finalizada`) y el loader se apaga (`loading`). Ese cambio es el
             * que se vigila para bajar la vista, sin temporizadores propios.
             */
            confirmacion_visible() {
                return this.compra_finalizada && !this.loading;
            }
        },
        watch: {
            /**
             * Al aparecer la confirmación, la vista se quedaba donde estaba el formulario
             * de pago y los botones («IMPRIMIR ENTRADAS», «Imprimir recibo de compra»)
             * quedaban fuera de pantalla. Se baja una única vez, igual que el aviso
             * `mapa-listo` de T59: enganchado al estado, no a un temporizador.
             */
            confirmacion_visible(visible) {
                if (!visible) {
                    return;
                }

                // El bloque se pinta en este mismo render: se espera al DOM para que
                // tenga ya su altura definitiva (loader fuera, botones dentro).
                this.$nextTick(() => this.scrollAConfirmacion());
            }
        },
        methods: {
            /**
             * Lleva la vista al bloque de la confirmación de compra. Se usa `scrollIntoView`
             * suave, como en `scrollAlPaso` del padre. Si el bloque aún no estuviera montado
             * se reintenta brevemente; la marca `confirmacion_desplazada` evita que un
             * re-render repita el salto.
             */
            scrollAConfirmacion(intentos = 5) {
                if (this.confirmacion_desplazada) {
                    return;
                }

                const bloque = this.$refs.confirmacionCompra;

                if (bloque && typeof bloque.scrollIntoView === 'function') {
                    this.confirmacion_desplazada = true;
                    bloque.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    return;
                }

                if (intentos > 0) {
                    setTimeout(() => this.scrollAConfirmacion(intentos - 1), 100);
                }
            },
            calcularDescuento(precio, descuento) {
                if (descuento === 0) {
                    return precio;
                }

                var desc = (descuento / 100) * precio;
                return precio - desc;
            },
            goTo(paso, zona_id) {
                this.$emit('goTo', paso, zona_id);
            },
            procesarCompraDatafono(data) {
                this.datos_compra.datafono_response = data;

                if(this.datafono_data){
                    this.datos_compra.datafono_id = this.datafono_data.id;
                }

                this.procesarCompra();
            },
            procesarCompra() {
                this.loading = true;
                if (this.datos_compra.entradas) {
                    this.datos_compra.entradas.forEach(entrada => {
                        entrada.price = entrada.precio;
                        entrada.price_management = entrada.price_management_taquilla;
                        entrada.price_management_interno = entrada.price_management_taquilla_interno;
                    });
                }

                var params = Object.assign({}, this.datos_compra);
                params.metodo_pago = params.metodo_pago.id;
                params.carrito_id = this.carrito_id;
                params.amigo_abonado_id = this.amigo_abonado_id
                params.filters = {};
                params.sesion_id = this.$route.params.sesion_id;

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.compra.taquilla'), params).then(res => {
                    this.compra_finalizada = true;
                    this.qr_codes = res.data.qr_codes;
                    this.mensaje_email = res.data.mensaje_email;
                    this.whatsapp_url = res.data.whatsapp_url;
                    this.pedido = res.data.pedido;

                    setTimeout(() => {
                        this.loading = false;
                    }, 3000);
                }).catch(e => {
                    this.loading = false;
                    this.error = e.response.data.message;
                });
            },
            getPrecioEntrada(precio) {
                let price = parseFloat(precio.precio);

                if(precio.price_management_interno_taquilla || precio.gd_interno) {
                    return price;
                }

                return price + parseFloat(precio.price_management_taquilla);
            },
            volverAtras() {
                this.$emit('volverAtras');
            },
        },
        components: {
            TitleComponent, PaymentCalculator, DatafonoComponent, Button
        }
    }
</script>
